<template>
  <v-container fluid class="success">
    <v-row align="center">
      <v-col
        cols="12"
        class="display-1 text-center white--text my-5">
          Interested in Sponsorship opportunities?
          <v-btn
          class="ml-5"
          outlined
          dark
          x-large
          href="mailto:team@entregoals.com?subject=Join the Sponsor Team!"
          >
        Get in Touch</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

  name: 'LandingSponsor',

  data() {
    return {

    };
  },
};
</script>

<style lang="css" scoped>
</style>
